import styles from './index.less';
import { Form, Input, Toast } from 'antd-mobile';
import editUrl from '@/assets/bindHouse/edit.png';
import BindButton from '@/pages/BindHouse/components/BindButton';
import { useEffect, useState } from 'react';
import BindResult from '@/pages/BindHouse/components/BindResult';
import { useModel, history } from '@umijs/max';
import {
  queryBindHouse,
  queryOwnerInfo,
  queryRoom,
} from '@/pages/BindHouse/service';
import SelectRoom from '@/pages/BindHouse/components/SelectRoom';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import type { selectedDataType } from './components/SelectRoom';

const BindHouse = () => {
  const [form] = Form.useForm();
  const { communityInfo, defaultCommunity } = useModel(
    'useCommunity',
    (model) => ({
      communityInfo: model.communityInfo,
      defaultCommunity: model.defaultCommunity,
    }),
  );
  const { openId, handleQueryWechatAccountInfo } = useModel(
    'useGlobal',
    (model) => ({
      openId: model.openId,
      handleQueryWechatAccountInfo: model.handleQueryWechatAccountInfo,
    }),
  );
  const [bindResult, setBindResult] = useState<'success' | 'lose'>('lose');
  const [bindResultVisible, setBindResultVisible] = useState<boolean>(false);
  const [bindButtonResult, setBindButtonResult] = useState<
    'proceed' | 'success'
  >('proceed');
  const [selectRoomVisible, setSelectRoomVisible] = useState<boolean>(false);
  const [selectRoomValue, setSelectRoomValue] = useState<selectedDataType>();

  const handleRoom = () => {
    queryRoom(defaultCommunity?.communityId ?? '').then((res) => {
      if (res?.code === 200) {
        console.log(res, 'query room  res');
      }
    });
  };

  useEffect(() => {
    handleRoom();
  }, []);

  const handlerQueryOwnerInfo = () => {
    if (!selectRoomValue?.ownerId) return;
    queryOwnerInfo(selectRoomValue?.ownerId || '').then((res) => {
      if (res?.code === 200) {
        form.setFieldsValue({
          ownerName: res?.data?.name ?? '',
          phoneNumber: res?.data?.phoneNumber ?? '',
        });
      }
    });
  };

  useEffect(() => {
    console.log(selectRoomValue, 'selectRoomValue');
    if (selectRoomValue?.label !== '') {
      form.setFieldsValue({
        house: selectRoomValue?.label as string,
      });
      handlerQueryOwnerInfo();
    }
  }, [selectRoomValue, form]);

  useEffect(() => {
    const community = communityInfo?.find((a) => a?.isDefault === 1);
    if (community) {
      form.setFieldsValue({
        communityName: community?.communityName,
      });
    }
  }, [communityInfo]);

  const handleConfirm = () => {
    if (!selectRoomValue?.roomId) {
      Toast.show({
        content: '请选择房间',
      });
      return;
    }
    if (!form.getFieldValue('phoneNumber')) {
      Toast.show({
        content: '请输入手机号',
      });
      return;
    }
    if (!form.getFieldValue('ownerName')) {
      Toast.show({
        content: '请输入业主姓名',
      });
      return;
    }
    queryBindHouse({
      communityId: defaultCommunity?.communityId,
      roomId: selectRoomValue?.roomId,
      openId: openId,
      userName: form.getFieldValue('ownerName'),
      phone: form.getFieldValue('phoneNumber'),
      isDefault: 1,
    }).then((res) => {
      if (res?.code === 200) {
        console.log(res, 'res');
        setBindButtonResult('success');
        setBindResultVisible(true);
        setBindResult('success');
        handleQueryWechatAccountInfo();
      } else {
        setBindResult('lose');
        setBindButtonResult('proceed');
      }
    });
  };

  const back = () => {
    history.push('/');
  };

  return (
    <div className={styles.container}>
      {!bindResultVisible ? (
        <Form
          className={styles['form-content']}
          form={form}
          layout={'horizontal'}
          mode={'card'}
        >
          <Form.Item label={'小区名称'} name={'communityName'}>
            <Input className={styles.input} placeholder={'请输入'} />
          </Form.Item>
          <Form.Item
            label={'房间'}
            name={'house'}
            extra={
              <>
                {selectRoomVisible ? (
                  <UpOutlined
                    style={{ color: '#999999' }}
                    className={styles.img}
                  />
                ) : (
                  <DownOutlined
                    style={{ color: '#999999' }}
                    className={styles.img}
                  />
                )}
              </>
            }
          >
            <Input
              onFocus={() => {
                // event.preventDefault();
                setSelectRoomVisible(true);
              }}
              className={styles.input}
              placeholder={'请选择'}
            />
          </Form.Item>
          <Form.Item
            label={'业主'}
            name={'ownerName'}
            extra={<img className={styles.img} src={editUrl} alt="edit" />}
          >
            <Input className={styles.input} placeholder={'请输入'} />
          </Form.Item>
          <Form.Item
            label={'手机号'}
            name={'phoneNumber'}
            extra={<img className={styles.img} src={editUrl} alt="edit" />}
          >
            <Input
              type={'number'}
              className={styles.input}
              placeholder={'请输入'}
            />
          </Form.Item>
        </Form>
      ) : (
        <BindResult result={bindResult} />
      )}
      <SelectRoom
        visible={selectRoomVisible}
        communityInfo={defaultCommunity}
        close={() => setSelectRoomVisible(false)}
        confirmSelect={setSelectRoomValue}
      />
      <BindButton
        type={bindButtonResult}
        btnClick={handleConfirm}
        backClick={back}
      />
    </div>
  );
};
export default BindHouse;
